// extracted by mini-css-extract-plugin
module.exports = {"main":"Image_main__gT4aM","slide-down":"Image_slide-down__1Bu8u","slide-up":"Image_slide-up__zkBPw"};